// extracted by mini-css-extract-plugin
export default {"cardWrapper":"InfoCard_cardWrapper__tid7p","cardTitle":"InfoCard_cardTitle__T68cC","cardDataName":"InfoCard_cardDataName__zaZT5"};